export default "__VITE_ASSET__CrK5ls3i__"